import { useContext } from 'react';
import { homeEquityContext } from '../context/HomeEquityContext';

export function useHomeEquity() {
  const value = useContext(homeEquityContext);
  return value;
}
